import { NOTICE_ES } from "./legal-notice-words-es.ts";
import { PRIVACY_ES } from "./legal-privacy-words-es.ts";
import { TERMS_ES } from "./legal-terms-words-es.ts";
import type { LegalWords } from "./legal-words.ts";

// Every legal word in Spanish, a translation: the English text controls (ADR-024, D701).

export const LEGAL_ES: LegalWords = {
  chrome: {
    footerTitle: "Legal",
    terms: "Términos",
    privacy: "Privacidad",
    notice: "Aviso legal",
    updated: "Última actualización: {date}",
    contents: "En esta página",
    languageNote:
      "Este texto es una traducción. Si difiere de la versión en inglés, prevalece el texto en inglés.",
  },
  terms: TERMS_ES,
  privacy: PRIVACY_ES,
  notice: NOTICE_ES,
};
